import {
  GET_SEARCH_PRODUCT_REQUEST,
  GET_SEARCH_PRODUCT_SUCCESS,
  GET_SEARCH_PRODUCT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const searchProduct = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEARCH_PRODUCT_REQUEST });
  const newData = {
    sku: values.sku
};
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/SearchProduct`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SEARCH_PRODUCT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEARCH_PRODUCT_ERROR,
        payload: [],
      });
    });
};
